export const MORE_LABEL = 'SCREEN_DETAIL_MORE_LABEL';
